import PropTypes from "prop-types";
import styles from "./FilterHeaderWarning.module.scss";
import FilterWarningLogo from "../../../../assets/icons/warning_icon.svg";

const FilterHeaderWarning = ({ children, styleClass }) => {
  if (!children) return null;
  return (
    <div className={`${styles.filterHeaderWarning} ${styleClass}`}>
      <img src={FilterWarningLogo} alt="Warning" />
      {children}
    </div>
  );
};
FilterHeaderWarning.propTypes = {
  children: PropTypes.node.isRequired,
  styleClass: PropTypes.string,
};

export default FilterHeaderWarning;
